module.exports = __webpack_public_path__ + "static/media/rnd.5afc84a0.jpg";